<template>
  <form @submit.prevent="handleSubmit(item)">
    <section class="content">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">{{$t('client.tabs.general')}}</h3>
        </div>
        <div class="box-body">
    <div class="form-group">
      <label for="company_name" class="form-control-label">{{$t('company.name')}}</label>
      <input
        id="company_name"
        v-model="item.name"
        :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('name', $event.target.value)">
      <div v-if="isInvalid('name')" class="invalid-feedback">{{ violations.name }}</div>
    </div>

    <div class="form-group">
      <label for="company_code" class="form-control-label">{{$t('company.code')}}</label>
      <input
        id="company_code"
        v-model.number="item.code"
        :class="['form-control', isInvalid('code') ? 'is-invalid' : '']"
        type="number"
        step="1">
      <div v-if="isInvalid('code')" class="invalid-feedback">{{ violations.code }}</div>
    </div>

    <div class="form-group">
      <label for="company_contactPerson" class="form-control-label">{{$t('company.contactPerson')}}</label>
      <input
              id="company_contactPerson"
              v-model="item.contactPerson"
              :class="['form-control', isInvalid('contactPerson') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('contactPerson', $event.target.value)">
      <div v-if="isInvalid('contactPerson')" class="invalid-feedback">{{ violations.contactPerson }}</div>
    </div>

            <div class="form-group">
                <label for="address_country" class="form-control-label">{{$t('address.country.name')}}</label>

                <v-select
                        id="address_country"
                        v-model="item.country"
                        :options="countries"
                        :class="['form-control-select2', isInvalid('country') ? 'is-invalid' : '']"
                        label="name"
                ></v-select>

                <div v-if="isInvalid('country')" class="invalid-feedback">{{ violations.country }}</div>
            </div>


            <div class="form-group">
                <label for="address_city" class="form-control-label">{{$t('address.city.name')}}</label>

                <v-select
                        id="address_city"
                        v-model="item.city"
                        :options="cities"
                        :class="['form-control-select2', isInvalid('city') ? 'is-invalid' : '']"
                        label="name"
                        @search="loadCities"
                ></v-select>

                <div v-if="isInvalid('city')" class="invalid-feedback">{{ violations.city }}</div>
            </div>

    <div class="form-group">
      <label for="company_region" class="form-control-label">{{$t('address.region')}}</label>
      <input
              id="company_region"
              v-model="item.region"
              :class="['form-control', isInvalid('region') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('region', $event.target.value)">
      <div v-if="isInvalid('region')" class="invalid-feedback">{{ violations.region }}</div>
    </div>

    <div class="form-group">
      <label for="company_district" class="form-control-label">{{$t('address.district')}}</label>
      <input
              id="company_district"
              v-model="item.district"
              :class="['form-control', isInvalid('district') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('district', $event.target.value)">
      <div v-if="isInvalid('district')" class="invalid-feedback">{{ violations.district }}</div>
    </div>

    <div class="form-group">
      <label for="company_postCode" class="form-control-label">{{$t('address.postCode')}}</label>
      <input
              id="company_postCode"
              v-model="item.postCode"
              :class="['form-control', isInvalid('postCode') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('postCode', $event.target.value)">
      <div v-if="isInvalid('postCode')" class="invalid-feedback">{{ violations.postCode }}</div>
    </div>

    <div class="form-group">
      <label for="company_street" class="form-control-label">{{$t('address.street')}}</label>
      <input
              id="company_street"
              v-model="item.street"
              :class="['form-control', isInvalid('street') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('street', $event.target.value)">
      <div v-if="isInvalid('street')" class="invalid-feedback">{{ violations.street }}</div>
    </div>

    <div class="form-group">
      <label for="company_building" class="form-control-label">{{$t('address.building')}}</label>
      <input
              id="company_building"
              v-model="item.building"
              :class="['form-control', isInvalid('building') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('building', $event.target.value)">
      <div v-if="isInvalid('building')" class="invalid-feedback">{{ violations.building }}</div>
    </div>

    <div class="form-group">
      <label for="company_apartment" class="form-control-label">{{$t('address.apartment')}}</label>
      <input
              id="company_apartment"
              v-model="item.apartment"
              :class="['form-control', isInvalid('apartment') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('apartment', $event.target.value)">
      <div v-if="isInvalid('apartment')" class="invalid-feedback">{{ violations.apartment }}</div>
    </div>

    <div class="form-group">
      <label for="company_description" class="form-control-label">{{$t('company.description')}}</label>
      <textarea
              id="company_description"
              v-model="item.description"
              :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
              placeholder=""
              @input="handleUpdateField('description', $event.target.value)"
              rows="1"
      ></textarea>
      <div v-if="isInvalid('description')" class="invalid-feedback">{{ violations.description }}</div>
    </div>

    <div class="form-group">
      <label for="company_comment" class="form-control-label">{{$t('company.comment')}}</label>
      <textarea
              id="company_comment"
              v-model="item.comment"
              :class="['form-control', isInvalid('comment') ? 'is-invalid' : '']"
              placeholder=""
              @input="handleUpdateField('comment', $event.target.value)"
              rows="10"
      ></textarea>
      <div v-if="isInvalid('comment')" class="invalid-feedback">{{ violations.comment }}</div>
    </div>

    <div class="form-group">
      <label
        for="company_labels"
        class="form-control-label">{{$t('company.labels.id')}}</label>

      <v-select multiple
                id="company_labels"
                v-model="item.labels"
                :options="labels"
                label="name"
      ></v-select>

      <div
        v-if="isInvalid('labels')"
        class="invalid-feedback">{{ violations.labels}}</div>
    </div>

      </div>
      </div>

      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">{{$t('client.tabs.contacts')}}</h3>
        </div>
        <div class="box-body">

          <button type="button" class="btn btn-info" @click.prevent="addContact()">
            <span class="fa fa-plus" aria-hidden="true" />
            <span>{{$t('contact.add')}}</span>
          </button>

          <table class="table table-striped">
            <thead>
            <tr>
              <th>{{$t('contact.value')}}</th>
              <th>{{$t('contact.contactType.name')}}</th>
              <th width="60px;"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="contact in item.contacts" :key="contact.id">
              <td>
                <input
                        id="contact_value"
                        v-model="contact.value"
                        :class="['form-control', isInvalid('value') ? 'is-invalid' : '']"
                        type="text">
                <div v-if="isInvalid('value')" class="invalid-feedback">{{ violations.value }}</div>
              </td>
              <td>
                <v-select
                        id="contact_contactType"
                        v-model="contact.contactType"
                        :options="contactTypes"
                        :class="['form-control-select2', isInvalid('contactType') ? 'is-invalid' : '']"
                        label="name"
                ></v-select>
                <div v-if="isInvalid('contactType')" class="invalid-feedback">{{ violations.contactType }}</div>
              </td>
              <td>
                <button type="button" class="btn btn-info" @click.prevent="removeContact(contact)">
                  <span class="fa fa-remove" aria-hidden="true" />
                  <span class="sr-only">{{$t('delete')}}</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <upload-image :item="item" property="images" :multiple="true" label="Images"></upload-image>
    <item-edit-actions :item="item" :entity="'Company'" :path="'company'"></item-edit-actions>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import lodash from 'lodash'
import ItemEditActions from '../layout/ItemEditActions'
import UploadImage from '../layout/UploadImage'

export default {
  components: {
    ItemEditActions,
    UploadImage,
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  mounted () {
    this.getLabels()
    this.getContactTypes()
    this.getCountries('/countries?itemsPerPage=500')
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    contactTypes () {
      return this.$store.getters['contact_type/list/items'] || []
    },

    violations () {
      return this.errors || {}
    },

    countries () {
      return this.$store.getters['country/list/items'] || []
    },

    cities () {
      return this.$store.getters['city/list/items'] || []
    },

    ...mapGetters({
      labels: 'label/list/items',
    }),
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    ...mapActions({
      getCountries: 'country/list/default',
      getCities: 'city/list/default',
      getContactTypes: 'contact_type/list/default',
      getLabels: 'label/list/default'
    }),

    loadCities (keyword, loading) {
      loading(true);
      this.searchCities(loading, keyword, this);
    },

    searchCities: _.debounce((loading, keyword, vm) => {
      vm.getCities('/cities?name=' + keyword)
      loading(false);
    }, 350),

    addContact () {
      this.item.contacts.push({
        uuid: Date.now(),
      })
    },
    removeContact (contact) {
      this.item.contacts = this.item.contacts.filter(function(el) {
        if (!contact.id) {
          contact.id = contact.uuid
        }

        return contact.id !== el.id;
      })
    },
  }
}
</script>
